import { getExtHostServices } from './extHost.js';
function create(getExtension) {
    return {
        registerCommand(id, command, thisArgs) {
            const { extHostCommands } = getExtHostServices();
            return extHostCommands.registerCommand(true, id, command, thisArgs, undefined, getExtension());
        },
        registerTextEditorCommand(id, callback, thisArg) {
            const { extHostCommands, extHostEditors, extHostLogService } = getExtHostServices();
            return extHostCommands.registerCommand(true, id, (...args) => {
                const activeTextEditor = extHostEditors.getActiveTextEditor();
                if (activeTextEditor == null) {
                    extHostLogService.warn('Cannot execute ' + id + ' because there is no active text editor.');
                    return undefined;
                }
                return activeTextEditor.edit((edit) => {
                    callback.apply(thisArg, [activeTextEditor, edit, ...args]);
                }).then((result) => {
                    if (!result) {
                        extHostLogService.warn('Edits from command ' + id + ' were not applied.');
                    }
                }, (err) => {
                    extHostLogService.warn('An error occurred while running command ' + id, err);
                });
            }, undefined, undefined, getExtension());
        },
        executeCommand(id, ...args) {
            const { extHostCommands } = getExtHostServices();
            return extHostCommands.executeCommand(id, ...args);
        },
        getCommands(filterInternal = false) {
            const { extHostCommands } = getExtHostServices();
            return extHostCommands.getCommands(filterInternal);
        }
    };
}
export { create as default };
